export default "__VITE_ASSET__D1SW_lAR__"